(function () {
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function money(n) {
    return '$' + Math.round(n).toLocaleString('en-US');
  }

  function addDays(base, days) {
    var d = new Date(base.getTime());
    d.setDate(d.getDate() + days);
    return d;
  }

  function fmtDate(d) {
    return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  }

  function initCar(root) {
    var builder = root.querySelector('[data-wheel-builder]');
    if (!builder) return;
    var prices = {};
    try { prices = JSON.parse(root.querySelector('[data-wheel-prices]').textContent || '{}'); } catch (e) { prices = {}; }
    var base = parseFloat(root.getAttribute('data-base')) || 0;
    var totals = root.querySelectorAll('[data-wheel-total]');
    var summary = root.querySelector('[data-wheel-summary]');
    var leds = root.querySelectorAll('[data-wheel-leds] i');
    var buildField = root.querySelector('[data-wheel-build-field]');
    var estimateField = root.querySelector('[data-wheel-estimate-field]');
    var formSummary = root.querySelector('[data-wheel-form-summary]');
    var variantSelect = root.querySelector('[data-wheel-variant]');

    function val(name) {
      var el = builder.querySelector('input[name="' + name + '"]:checked');
      return el ? el.value : '';
    }
    function on(name) {
      var el = builder.querySelector('input[name="' + name + '"]');
      return !!(el && el.checked);
    }

    function state() {
      var finish = val('finish');
      var led = on('led');
      var paddles = on('paddles');
      var extras = 'None';
      if (led && paddles) extras = 'LED shift display + carbon paddles';
      else if (led) extras = 'LED shift display';
      else if (paddles) extras = 'Carbon paddles';
      var heating = on('heating') ? 'Keep my heated wheel' : 'No heating';
      var key = finish + '|' + extras + '|' + heating;
      var price = prices[key];
      if (typeof price !== 'number') {
        price = base;
        builder.querySelectorAll('input:checked[data-add]').forEach(function (i) { price += parseFloat(i.getAttribute('data-add')) || 0; });
      }
      return {
        finish: finish, grip: val('grip'), stitching: val('stitching'), marker: val('marker'),
        led: led, paddles: paddles, heating: heating, extras: extras, price: price
      };
    }

    function describe(s) {
      var parts = [s.finish.replace(' carbon-pattern', '') + ' finish', s.grip.toLowerCase() + ' grips', s.stitching.toLowerCase() + ' stitching'];
      parts.push(s.marker === 'None' ? 'no top marker' : s.marker.toLowerCase() + ' top marker');
      if (s.led) parts.push('LED shift display');
      if (s.paddles) parts.push('carbon paddles');
      if (s.heating === 'Keep my heated wheel') parts.push('heated wheel kept');
      var text = parts.join(', ');
      return text.charAt(0).toUpperCase() + text.slice(1) + '.';
    }

    function update() {
      var s = state();
      var text = describe(s);
      totals.forEach(function (t) { t.textContent = money(s.price); });
      if (summary) summary.textContent = text;
      var lit = 2;
      if (s.finish.indexOf('Forged') === 0) lit += 1;
      if (s.finish.indexOf('Coloured') === 0) lit += 2;
      if (s.led) lit += 2;
      if (s.paddles) lit += 1;
      if (s.heating === 'Keep my heated wheel') lit += 1;
      leds.forEach(function (l, i) { l.classList.toggle('is-on', i < Math.min(lit, leds.length)); });
      if (buildField) buildField.value = text + ' Estimated ' + money(s.price) + '.';
      if (estimateField) estimateField.value = money(s.price);
      if (formSummary) formSummary.textContent = 'Your build: ' + text + ' Estimated ' + money(s.price) + '. You can change it later by email.';
      if (variantSelect) {
        var want = s.finish + '|' + s.extras + '|' + s.heating;
        var match = null;
        Array.prototype.forEach.call(variantSelect.options, function (o) {
          if (!match && !o.disabled && o.getAttribute('data-opts') === want) match = o;
        });
        variantSelect.value = match ? match.value : '';
        root.querySelectorAll('.wheel-car__buy [data-wheel-cta], [data-wheel-sticky-buy]').forEach(function (b) {
          b.disabled = !match;
          b.textContent = match ? 'Add to bag' : 'This build is not available';
        });
        root.querySelectorAll('[data-prop]').forEach(function (h) { h.value = s[h.getAttribute('data-prop')] || ''; });
      }
    }

    builder.addEventListener('change', update);
    update();

    // A build is kept per car page in this browser and can be shared as a link. Only option values go in the URL.
    var storeKey = 'mm-wheel-build:' + location.pathname;
    var fields = ['finish', 'grip', 'stitching', 'marker'];
    var toggles = ['led', 'paddles', 'heating'];
    var restored = root.querySelector('[data-wheel-restored]');
    var share = root.querySelector('[data-wheel-share]');
    var copyStatus = root.querySelector('[data-wheel-copy-status]');

    function choices() {
      var c = {};
      fields.forEach(function (n) { c[n] = val(n); });
      toggles.forEach(function (n) { if (on(n)) c[n] = '1'; });
      return c;
    }
    function apply(c) {
      var changed = false;
      fields.forEach(function (n) {
        if (typeof c[n] !== 'string') return;
        builder.querySelectorAll('input[name="' + n + '"]').forEach(function (i) {
          if (i.value === c[n] && !i.checked) { i.checked = true; changed = true; }
        });
      });
      toggles.forEach(function (n) {
        var i = builder.querySelector('input[name="' + n + '"]');
        if (i && i.checked !== (c[n] === '1')) { i.checked = c[n] === '1'; changed = true; }
      });
      return changed;
    }
    function withoutBuild(search) {
      var q = new URLSearchParams(search);
      fields.concat(toggles).forEach(function (n) { q.delete(n); });
      return q;
    }
    function fromUrl() {
      var q = new URLSearchParams(location.search);
      if (!fields.some(function (n) { return q.has(n); })) return null;
      var c = {};
      fields.forEach(function (n) { if (q.get(n)) c[n] = q.get(n).slice(0, 60); });
      toggles.forEach(function (n) { if (q.get(n) === '1') c[n] = '1'; });
      return c;
    }
    function fromStore() {
      try {
        var c = JSON.parse(localStorage.getItem(storeKey) || 'null');
        return c && typeof c === 'object' ? c : null;
      } catch (e) { return null; }
    }
    var linked = fromUrl();
    var saved = linked || fromStore();
    if (saved && apply(saved)) {
      update();
      if (restored) {
        restored.querySelector('[data-wheel-restored-text]').textContent = linked ? 'This is the build from your link.' : 'This is the build you made here last time.';
        restored.hidden = false;
      }
    }
    builder.addEventListener('change', function () {
      try { localStorage.setItem(storeKey, JSON.stringify(choices())); } catch (e) {}
    });
    var reset = root.querySelector('[data-wheel-reset]');
    if (reset) reset.addEventListener('click', function () {
      builder.querySelectorAll('input').forEach(function (i) { i.checked = i.defaultChecked; });
      try { localStorage.removeItem(storeKey); } catch (e) {}
      if (linked && window.history.replaceState) {
        var qs = withoutBuild(location.search).toString();
        window.history.replaceState(null, '', location.pathname + (qs ? '?' + qs : '') + location.hash);
        linked = null;
      }
      update();
      restored.hidden = true;
      var next = root.querySelector('[data-wheel-copy]');
      if (next && share && !share.hidden) next.focus({ preventScroll: true });
    });
    var copy = root.querySelector('[data-wheel-copy]');
    if (share && copy && window.URLSearchParams) {
      share.hidden = false;
      copy.addEventListener('click', function () {
        // Only the template view and the build go in the link, never ?contact_posted or other form state.
        var q = new URLSearchParams();
        var view = new URLSearchParams(location.search).get('view');
        if (view) q.set('view', view);
        var c = choices();
        Object.keys(c).forEach(function (n) { q.set(n, c[n]); });
        var url = location.origin + location.pathname + '?' + q.toString();
        function done(ok) { copyStatus.textContent = ok ? 'Link copied.' : 'Copy this link: ' + url; }
        if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(url).then(function () { done(true); }, function () { done(false); });
        else done(false);
      });
    }

    var arrival = root.querySelector('[data-wheel-arrival]');
    var bmin = parseInt(root.getAttribute('data-build-min'), 10);
    var bmax = parseInt(root.getAttribute('data-build-max'), 10);
    var smin = parseInt(root.getAttribute('data-ship-min'), 10);
    var smax = parseInt(root.getAttribute('data-ship-max'), 10);
    if (arrival && bmin && bmax && smin && smax) {
      var today = new Date();
      var buying = root.getAttribute('data-buyable') === 'true';
      var arrivalWindow = fmtDate(addDays(today, bmin + smin)) + ' to ' + fmtDate(addDays(today, bmax + smax));
      arrival.innerHTML = '<strong>Estimated arrival:</strong> ' + arrivalWindow +
        (buying ? ' if you order today.' : ' if you approve your build today.') + ' That is about ' + bmin + '-' + bmax + ' calendar days to build to order, then ' + smin + '-' + smax +
        ' days shipping with tracking. ' + (buying ? 'We email you the build time when we confirm your fit.' : 'Your quote confirms the build time.');
      var arrivalField = root.querySelector('[data-wheel-arrival-field]');
      if (arrivalField) arrivalField.value = arrivalWindow + ' (shown ' + fmtDate(today) + ')';
    }

    function goToForm(focusVin) {
      var form = root.querySelector('[data-wheel-quote]') || root.querySelector('[data-wheel-buy]');
      if (!form) return;
      form.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
      var target = focusVin ? form.querySelector('[data-wheel-vin]') : form.querySelector('input[type="text"]:not([type="hidden"])');
      if (target) setTimeout(function () { target.focus({ preventScroll: true }); }, reduceMotion ? 0 : 450);
    }
    root.querySelectorAll('[data-wheel-open]').forEach(function (a) {
      a.addEventListener('click', function (e) { e.preventDefault(); goToForm(false); });
    });
    var check = root.querySelector('[data-wheel-check]');
    if (check) check.addEventListener('click', function (e) { e.preventDefault(); goToForm(true); });
    var stickyBuy = root.querySelector('[data-wheel-sticky-buy]');
    if (stickyBuy) stickyBuy.addEventListener('click', function () {
      var buy = root.querySelector('[data-wheel-buy]');
      if (!buy || stickyBuy.disabled) return;
      if (typeof buy.requestSubmit === 'function') buy.requestSubmit();
      else if (buy.reportValidity()) buy.submit();
    });

    var done = root.querySelector('[data-wheel-done]');
    if (done) setTimeout(function () { done.focus(); }, 60);

    var sticky = root.querySelector('[data-wheel-sticky]');
    var cta = root.querySelector('.wheel-car__info [data-wheel-cta]');
    var formBox = root.querySelector('.wheel-quote') || root.querySelector('[data-wheel-buy]');
    if (sticky && cta && 'IntersectionObserver' in window) {
      var ctaVisible = true, formVisible = false, typing = false, past = false;
      function sync() { sticky.hidden = ctaVisible || formVisible || typing || !past; }
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          ctaVisible = en.isIntersecting;
          past = !en.isIntersecting && en.boundingClientRect.top < 0;
        });
        sync();
      }).observe(cta);
      if (formBox) new IntersectionObserver(function (entries) { entries.forEach(function (en) { formVisible = en.isIntersecting; }); sync(); }).observe(formBox);
      document.addEventListener('focusin', function (e) { typing = /^(INPUT|TEXTAREA|SELECT)$/.test(e.target.tagName) && e.target.type !== 'radio' && e.target.type !== 'checkbox'; sync(); });
      document.addEventListener('focusout', function () { typing = false; sync(); });
    }

    var slides = root.querySelector('.wheel-car__slides');
    var index = root.querySelector('[data-wheel-slide-index]');
    if (slides && index) {
      slides.addEventListener('scroll', function () {
        var i = Math.round(slides.scrollLeft / Math.max(1, slides.clientWidth));
        index.textContent = String(i + 1);
      }, { passive: true });
    }
  }

  function initPickers() {
    document.querySelectorAll('[data-wheel-picker]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        var sel = form.querySelector('select');
        var target = sel ? sel.value.trim() : '';
        if (target.charAt(0) === '/') {
          e.preventDefault();
          window.location.href = target;
        }
      });
    });
  }

  function start() {
    document.querySelectorAll('[data-wheel-car]').forEach(initCar);
    initPickers();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
